<ion-card>
  <ion-card-header>
    <ion-card-title>KRÉTA-feljegyzések – szinkron</ion-card-title>
    <ion-card-subtitle>
      A KRÉTA feljegyzéseinek és tantárgyi felmentéseinek átvétele, a visszaírandók
    </ion-card-subtitle>
  </ion-card-header>

  <ion-card-content>
    <div *ngIf="toltodik"><ion-spinner name="dots"></ion-spinner> Betöltés…</div>
    <div class="kf-hiba" *ngIf="hiba">{{ hiba }}</div>

    <ng-container *ngIf="!toltodik && !hiba">
      <p class="kf-lead">
        A szinkron belép egy már felvett KRÉTA-fiókkal (<b>Adminisztrációs rendszer</b> szerepkör), és
        letölti a <b>Feljegyzések listáját</b> és a <b>Felmentések listáját</b>. A feljegyzések abba a
        nyilvántartásba kerülnek, amelyet a tanárok (<a routerLink="/ertekelesek/3">Értékelések → Feljegyzés</a>),
        az osztályfőnök (Tanórai feljegyzések) és a szülők is látnak; a hiányzó feljegyzés-típusokat a KRÉTA
        típuslistájából felveszi. A tantárgyi felmentések a <b>napló névsorában</b> jelennek meg.
        <b>A KRÉTÁ-ban nem változtat semmit.</b>
      </p>

      <h3 class="kf-cim">Kapcsolat</h3>
      <div class="kf-racs">
        <ion-item>
          <ion-label position="stacked">KRÉTA-fiók a belépéshez</ion-label>
          <ion-select [(ngModel)]="b.forras_allomany" interface="popover" placeholder="– válassz fiókot –">
            <ion-select-option *ngFor="let f of fiokok" [value]="f.allomany">
              {{ f.tanar_nev || f.allomany }} ({{ f.kreta_user }})
            </ion-select-option>
          </ion-select>
        </ion-item>
        <ion-item lines="none">
          <ion-checkbox [(ngModel)]="b.automatikus" labelPlacement="end">
            Éjszakánként magától (hajnali 3 és 6 óra között)
          </ion-checkbox>
        </ion-item>
        <ion-item lines="none">
          <ion-checkbox [(ngModel)]="b.visszairas_auto" labelPlacement="end">
            Automatikus visszaírás a KRÉTÁ-ba (az itt rögzített, módosított, törölt feljegyzések pár percen belül kimennek)
          </ion-checkbox>
        </ion-item>
      </div>
      <ion-note color="medium" class="kf-megj" *ngIf="!fiokok.length">
        Még nincs felvett KRÉTA-fiók. A fiókokat az <b>E-napló → KRÉTA naplózás</b> menüben lehet
        felvenni; a szinkronhoz olyan fiók kell, amelynek van <b>Adminisztrációs rendszer</b> szerepköre.
      </ion-note>
      <ion-note color="medium" class="kf-megj" *ngIf="fiokok.length">
        A kiválasztott fióknak a KRÉTÁ-ban <b>Adminisztrációs rendszer</b> szerepkörrel kell rendelkeznie.
        A KRÉTA a listát a fiókban <b>kiválasztott tanévre</b> adja.
      </ion-note>

      <div class="kf-gombok">
        <ion-button size="small" fill="outline" (click)="mentes()" [disabled]="ment">Beállítás mentése</ion-button>
        <ion-button size="small" (click)="szinkron()" [disabled]="folyamat?.fut || !b.forras_allomany">
          <ion-icon slot="start" name="sync-outline"></ion-icon>
          Szinkron indítása most
        </ion-button>
      </div>

      <div class="kf-allapot" *ngIf="folyamat?.fut">
        <ion-spinner name="dots"></ion-spinner>
        <span>Fut: <b>{{ folyamat.lepes }}</b></span>
      </div>
      <div class="kf-allapot jo" *ngIf="folyamat && !folyamat.fut && folyamat.eredmeny">
        Kész: {{ folyamat.eredmeny.kreta_db }} KRÉTA-feljegyzés – {{ folyamat.eredmeny.uj }} új,
        {{ folyamat.eredmeny.frissitett }} frissült, {{ folyamat.eredmeny.torolt }} törölve.
        <span *ngIf="folyamat.eredmeny.tipus_uj">{{ folyamat.eredmeny.tipus_uj }} új feljegyzés-típus.</span>
        <span>{{ folyamat.eredmeny.felmentes_db }} tantárgyi felmentés.</span>
        <span *ngIf="folyamat.eredmeny.helyi_elsobbseg">
          {{ folyamat.eredmeny.helyi_elsobbseg }} itt módosított tételt nem írt felül.
        </span>
        <span *ngIf="folyamat.eredmeny.parositatlan || folyamat.eredmeny.felmentes_parositatlan">
          {{ folyamat.eredmeny.parositatlan + folyamat.eredmeny.felmentes_parositatlan }} tétel tanulóját nem találtuk.
        </span>
      </div>
      <div class="kf-allapot baj" *ngIf="folyamat && !folyamat.fut && folyamat.hiba">
        A szinkron nem sikerült: {{ folyamat.hiba }}
      </div>

      <ng-container *ngIf="osszesito">
        <h3 class="kf-cim">Nyilvántartás</h3>
        <div class="kf-szamok">
          <div><span class="szam">{{ osszesito.tetel }}</span><span>feljegyzés</span></div>
          <div><span class="szam">{{ osszesito.kretabol }}</span><span>a KRÉTÁ-ból</span></div>
          <div><span class="szam">{{ osszesito.sulinformbol }}</span><span>itt rögzítve</span></div>
          <div [class.var]="osszesito.visszairasra_var > 0">
            <span class="szam">{{ osszesito.visszairasra_var }}</span><span>KRÉTÁ-ba visszaírandó</span>
          </div>
          <div [class.baj]="osszesito.parositatlan > 0">
            <span class="szam">{{ osszesito.parositatlan }}</span><span>tanuló nélkül</span>
          </div>
          <div *ngIf="felmentes">
            <span class="szam">{{ felmentes.ervenyes }}</span><span>érvényes tantárgyi felmentés</span>
          </div>
          <div *ngIf="tipusok">
            <span class="szam">{{ tipusok.db }}</span><span>típus, ebből {{ tipusok.csak_admin }} csak adminé</span>
          </div>
        </div>
        <ion-note color="medium" class="kf-megj">
          Hogy melyik típust rögzítheti a pedagógus és melyiket csak admin (határozat, záradék, törzslapra
          kerülő bejegyzés), az <b>E-napló → Feljegyzés-típusok</b> képernyőn állítható.
        </ion-note>
      </ng-container>

      <ng-container *ngIf="visszairando.length">
        <h3 class="kf-cim">KRÉTÁ-ba visszaírandó feljegyzések</h3>
        <ion-note color="medium" class="kf-megj">
          Ezeket itt rögzítették, módosították vagy törölték.
          <ng-container *ngIf="!elesitve"><b>Az automatikus visszaírás ki van kapcsolva</b>: amíg az, a KRÉTÁ-ban
            kézzel kell átvezetni őket.</ng-container>
          <ng-container *ngIf="elesitve"><b>Az automatikus visszaírás be van kapcsolva:</b> a tételek a rögzítő
            tanár saját KRÉTA-fiókjával mennek ki (ő lesz a feljegyző), 20 percenként; a hibás tétel óránként újrapróbálkozik.</ng-container>
          A következő szinkron addig sem írja felül az itteni változatot, amíg a változás a KRÉTÁ-ba nem kerül.
        </ion-note>
        <div class="kf-tabla-burok">
          <table class="kf-tabla">
            <thead>
              <tr><th>Tanuló</th><th>Dátum</th><th>Típus</th><th>Változás</th><th>Ki</th><th>Hiányzik a küldéshez</th></tr>
            </thead>
            <tbody>
              <tr *ngFor="let v of visszairando">
                <td>{{ v.nev || v.tanulo }}</td>
                <td class="datum">{{ v.datum }}</td>
                <td class="tipus" [title]="v.tipus">{{ v.tipus }}</td>
                <td>{{ muveletNev(v.muvelet) }}</td>
                <td>{{ v.ki || '—' }}</td>
                <td class="hiany">
                  <span *ngIf="!v.hianyzik?.length" class="jel jo">minden megvan</span>
                  <span *ngFor="let h of v.hianyzik" class="jel var" [title]="h">{{ h }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="kf-gombok">
          <ion-button size="small" fill="outline" (click)="szarazFutas()" [disabled]="tervToltodik">
            <ion-icon slot="start" name="eye-outline"></ion-icon>
            Visszaírás – száraz futás
          </ion-button>
          <ion-button size="small" *ngIf="elesitve" (click)="kuldesMost()" [disabled]="kuld">
            <ion-icon slot="start" name="cloud-upload-outline"></ion-icon>
            {{ kuld ? 'Küldés folyamatban…' : 'Küldés a KRÉTÁ-ba most' }}
          </ion-button>
        </div>
        <ion-note color="medium" class="kf-megj">
          A száraz futás megmutatja, milyen kérést küldene a rendszer a KRÉTÁ-nak (végpont, szerepkör, fiók,
          törzs) – <b>semmit nem küld el</b>.
        </ion-note>

        <div class="kf-terv" *ngIf="terv">
          <div *ngIf="!terv.length" class="kf-megj">Nincs visszaírandó tétel.</div>
          <div class="kf-terv-tetel" *ngFor="let t of terv">
            <div class="kf-terv-fej" (click)="nyitottTerv[t.id] = !nyitottTerv[t.id]">
              <ion-icon [name]="nyitottTerv[t.id] ? 'chevron-down-outline' : 'chevron-forward-outline'"></ion-icon>
              <b>{{ t.nev }}</b> · {{ t.tipus }} · {{ muveletNev(t.muvelet) }}
              <span class="jel" [class.jo]="t.kuldheto" [class.var]="!t.kuldheto">{{ t.kuldheto ? 'küldhető' : 'hiányos' }}</span>
            </div>
            <div class="kf-terv-reszlet" *ngIf="nyitottTerv[t.id]">
              <div><b>{{ t.keres.modszer }}</b> {{ t.keres.vegpont }} · szerepkör: {{ t.keres.szerepkor }}
                · fiók: {{ t.fiok || '—' }}<span *ngIf="t.fiok && !t.fiok_sajat"> (nem a rögzítőé – a KRÉTÁ-ban ő lesz a feljegyző)</span></div>
              <pre>{{ json(t.keres.torzs) }}</pre>
              <div *ngIf="t.elozo_hiba" class="kf-hiba">Előző próbálkozás: {{ t.elozo_hiba }}</div>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="parositatlan.length">
        <h3 class="kf-cim">Tanuló nélküli KRÉTA-feljegyzések</h3>
        <ion-note color="medium" class="kf-megj">
          Ezeknek a tanulóját nem találtuk meg a nyilvántartásban (az oktatási azonosító alapján). Ha a
          tanulót később felvesszük, a feljegyzés magától hozzá kerül.
        </ion-note>
        <div class="kf-tabla-burok">
          <table class="kf-tabla">
            <thead><tr><th>Tanuló (KRÉTA)</th><th>Osztály</th><th>Dátum</th><th>Típus</th></tr></thead>
            <tbody>
              <tr *ngFor="let p of parositatlan">
                <td>{{ p.nev }}</td><td>{{ p.osztaly }}</td><td class="datum">{{ p.datum }}</td>
                <td class="tipus" [title]="p.tipus">{{ p.tipus }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>

      <ng-container *ngIf="felmentesParositatlan.length">
        <h3 class="kf-cim">Tanuló nélküli tantárgyi felmentések</h3>
        <ion-note color="medium" class="kf-megj">
          A KRÉTA felmentés-listája a tanulót csak névvel és osztállyal adja; ezeknél a név és az osztály nem
          azonosított egyértelműen egy tanulót.
        </ion-note>
        <div class="kf-tabla-burok">
          <table class="kf-tabla">
            <thead><tr><th>Tanuló (KRÉTA)</th><th>Osztály</th><th>Tantárgy</th></tr></thead>
            <tbody>
              <tr *ngFor="let p of felmentesParositatlan">
                <td>{{ p.nev }}</td><td>{{ p.osztaly }}</td><td>{{ p.tantargy }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>

      <ng-container *ngIf="futasok.length">
        <h3 class="kf-cim">Korábbi szinkronok</h3>
        <div class="kf-tabla-burok">
          <table class="kf-tabla">
            <thead>
              <tr><th>Indult</th><th>Állapot</th><th>Indította</th><th class="szam">KRÉTA</th><th class="szam">Új</th>
                <th class="szam">Frissült</th><th class="szam">Törölve</th><th class="szam">Tanuló nélkül</th>
                <th class="szam">Új típus</th><th class="szam">Felmentés</th></tr>
            </thead>
            <tbody>
              <tr *ngFor="let f of futasok">
                <td class="datum">{{ f.indult }}</td>
                <td>
                  <span class="jel jo" *ngIf="f.allapot === 'kesz'">kész</span>
                  <span class="jel" *ngIf="f.allapot === 'fut'">fut</span>
                  <span class="jel baj" *ngIf="f.allapot === 'hiba'" [title]="f.hiba || ''">hiba</span>
                </td>
                <td>{{ f.inditotta || '—' }}</td>
                <td class="szam">{{ f.kreta_db ?? '—' }}</td>
                <td class="szam">{{ f.uj ?? '—' }}</td>
                <td class="szam">{{ f.frissitett ?? '—' }}</td>
                <td class="szam">{{ f.torolt ?? '—' }}</td>
                <td class="szam">{{ f.parositatlan_db ?? '—' }}</td>
                <td class="szam">{{ f.tipus_uj ?? '—' }}</td>
                <td class="szam">{{ f.felmentes_db ?? '—' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>
    </ng-container>
  </ion-card-content>
</ion-card>
